import { Outlet } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import Header from './Header';

export default function OtherPageLayout() {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', bgcolor: 'background.paper' }}>
            <Header />
            <Box sx={{ borderBottom: '1px solid', borderColor: 'divider' }}>
                <Button
                    variant="text"
                    size="small"
                    startIcon={<ArrowBackIcon sx={{ width: 14, height: 14 }} />}
                    href="/"
                    sx={{ textTransform: 'none' }}
                >
                    Назад к измерениям
                </Button>
            </Box>
            <Outlet />
        </Box>
    );
}
